import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, LayoutDashboardIcon, SparklesIcon } from 'lucide-react';
export function ProductsSection() {
  return <section className="section-padding bg-black relative border-y border-white/5" data-id="element-136">
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-overlay pointer-events-none" data-id="element-137" />

      <div className="text-center max-w-3xl mx-auto mb-16 relative z-10" data-id="element-138">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-139">Our Products</h2>
        <p className="text-xl text-gray-400" data-id="element-140">
          Premium tools built to accelerate your ecommerce growth.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 relative z-10" data-id="element-141">
        {/* Themes Card */}
        <div className="group relative overflow-hidden rounded-3xl bg-gradient-to-b from-white/[0.08] to-transparent border border-white/10 p-1 hover:border-[#D4AF37]/30 transition-colors duration-500" data-id="element-142">
          <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-143" />
          <div className="relative h-full bg-[#0a0a0a] rounded-[23px] p-8 md:p-10 flex flex-col" data-id="element-144">
            {/* Browser Frame with Scrolling Image */}
            <div className="w-full aspect-[16/10] rounded-xl border border-white/10 bg-black mb-8 overflow-hidden flex flex-col shadow-2xl" data-id="element-145">
              {/* Browser Header */}
              <div className="h-8 bg-white/5 border-b border-white/10 flex items-center px-3 gap-1.5 shrink-0" data-id="element-146">
                <div className="w-2.5 h-2.5 rounded-full bg-red-500/50" data-id="element-147" />
                <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/50" data-id="element-148" />
                <div className="w-2.5 h-2.5 rounded-full bg-green-500/50" data-id="element-149" />
              </div>
              {/* Scroll Area */}
              <div className="relative flex-1 overflow-hidden" data-id="element-150">
                <img src="https://picsum.photos/seed/theme/800/1600" alt="Theme Preview" loading="lazy" className="w-full h-auto object-cover object-top absolute top-0 left-0 transition-transform duration-[4000ms] ease-in-out group-hover:-translate-y-[50%]" data-id="element-151" />
              </div>
            </div>

            <div className="flex items-center gap-4 mb-4" data-id="element-152">
              <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center border border-white/10" data-id="element-153">
                <LayoutDashboardIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-154" />
              </div>
              <h3 className="text-3xl font-bold text-white" data-id="element-155">Shopify Themes</h3>
            </div>

            <p className="text-lg text-gray-400 mb-8" data-id="element-156">
              Professional themes built for modern merchants. Clean design.
              Lightning speed. Built to convert.
            </p>
            <div className="mt-auto" data-id="element-157">
              <Link to="/products#themes" className="inline-flex items-center gap-2 text-white font-semibold hover:text-[#D4AF37] transition-colors" data-id="element-158">
                Explore Themes{' '}
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-159" />
              </Link>
            </div>
          </div>
        </div>

        {/* Apps Card */}
        <div className="group relative overflow-hidden rounded-3xl bg-gradient-to-b from-white/[0.08] to-transparent border border-white/10 p-1 hover:border-[#D4AF37]/30 transition-colors duration-500" data-id="element-160">
          <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-161" />
          <div className="relative h-full bg-[#0a0a0a] rounded-[23px] p-8 md:p-10 flex flex-col" data-id="element-162">
            {/* Browser Frame with Scrolling Image */}
            <div className="w-full aspect-[16/10] rounded-xl border border-white/10 bg-black mb-8 overflow-hidden flex flex-col shadow-2xl" data-id="element-163">
              {/* Browser Header */}
              <div className="h-8 bg-white/5 border-b border-white/10 flex items-center px-3 gap-1.5 shrink-0" data-id="element-164">
                <div className="w-2.5 h-2.5 rounded-full bg-red-500/50" data-id="element-165" />
                <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/50" data-id="element-166" />
                <div className="w-2.5 h-2.5 rounded-full bg-green-500/50" data-id="element-167" />
              </div>
              {/* Scroll Area */}
              <div className="relative flex-1 overflow-hidden" data-id="element-168">
                <img src="https://cdn.magicpatterns.com/uploads/kv1PVsUPv2J3UAjP8rqfyZ/CleanShot_2026-03-17_at_20.47.25.png" alt="AI Product Photoshoot - Shopify App Store" loading="lazy" className="w-full h-auto object-cover object-top absolute top-0 left-0 transition-transform duration-[4000ms] ease-in-out group-hover:-translate-y-[50%]" data-id="element-169" />
              </div>
            </div>

            <div className="flex items-center gap-4 mb-4" data-id="element-170">
              <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center border border-white/10" data-id="element-171">
                <SparklesIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-172" />
              </div>
              <h3 className="text-3xl font-bold text-white" data-id="element-173">Shopify Apps</h3>
            </div>

            <p className="text-lg text-gray-400 mb-8" data-id="element-174">
              Smart tools designed to improve store performance and sales.
              Automation. Analytics. Conversion tools.
            </p>
            <div className="mt-auto" data-id="element-175">
              <Link to="/products#apps" className="inline-flex items-center gap-2 text-white font-semibold hover:text-[#D4AF37] transition-colors" data-id="element-176">
                Explore Apps{' '}
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-177" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}